import { Component, OnInit, inject, ViewChild, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms'; // Importa FormsModule
import { CommonModule, formatDate } from '@angular/common';
//import { DomSanitizer, SafeResourceUrl   } from "@angular/platform-browser";
import { NgbDatepickerModule, NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormArray, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms'
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from "../../modal/modal.component";
import { InicioService } from '../../../services/inicio.service';
import { EvaluacionEtService } from '../../../services/evaluacion-et.service';
import { I18n, CustomDatepickerI18n } from '../../../clases/idioma-fecha';

@Component({
  selector: 'app-calculo-cuota',
  standalone: true,
  imports: [ModalComponent, CommonModule, FormsModule, NgbDatepickerModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './calculo-cuota.component.html',
  styleUrl: './calculo-cuota.component.css',
  providers: [
    provideNgxMask(),
    I18n,
    { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }
  ],
})
export class CalculoCuotaComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() vuelve = new EventEmitter<any>();
  @Input() id_empresa?: any;
  @Input() nombre_empresa?: any;
  @Input() rif?: any;
  @Input() id_estado?: any;
  @Input() arrEstado?: any;
  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  user: any;
  errorMessage: string = '';
  years: number[] = [];
  selectedYear: number = 0;
  estado: any = [];

  resultado: any = [];
  //resultado: any[] = [];
  //filteredResultado: any[] = [];
  //searchTerm: string = '';

  aspirantesSeleccionados: any[] = []; // Array para guardar los IDs de los aspirantes seleccionados

  valor: boolean = false;

  textoBoton: string = '';

  private srvLogin = inject(InicioService);
  private servicios = inject(EvaluacionEtService);
  private modalService = inject(NgbModal);

  formularioRegistro: FormGroup;

  constructor( private fb:FormBuilder ){
    this.formularioRegistro = this.fb.group({
      //--------Datos personales
      anio: ['', Validators.required],
      enero: ['', Validators.required],
      febrero: ['', Validators.required],
      marzo: ['', Validators.required],
      abril: ['', Validators.required],
      mayo: ['', Validators.required],
      junio: ['', Validators.required],
      julio: ['', Validators.required],
      agosto: ['', Validators.required],
      septiembre: ['', Validators.required],
      octubre: ['', Validators.required],
      noviembre: ['', Validators.required],
      diciembre: ['', Validators.required],
      promedio: ['', Validators.required],
      cuota: ['', Validators.required],
    });
  }


  ngOnInit(): void {
    this.getFullYear();
    this.srvLogin.user$.subscribe(user => { this.user = user; });
  }
  //consultar esta empresa G200002123
  ngAfterViewInit(): void {
    console.log(this.id_empresa);
    this.mdl.cargando();
    this.servicios.calculoCuota(this.id_empresa).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.resultado = rs.data;

        if(this.resultado.length == 0){
          this.textoBoton = 'Aceptar';
          this.formularioRegistro.get('anio')?.setValue(this.selectedYear);
          console.log('ooooooooo:  ',this.resultado.length)
        }
        else{
          console.log('ooooooooo:  ',this.resultado[0])
          this.textoBoton = 'Editar';
          this.formularioRegistro.patchValue({
            //El signo de exclamación(!) se utiliza para afirmar que el valor no es nulo
            anio: this.resultado[0].ano,
            enero: this.resultado[0].enero,
            febrero: this.resultado[0].febrero,
            marzo: this.resultado[0].marzo,
            abril: this.resultado[0].abril,
            mayo: this.resultado[0].mayo,
            junio: this.resultado[0].junio,
            julio: this.resultado[0].julio,
            agosto: this.resultado[0].agosto,
            septiembre: this.resultado[0].septiembre,
            octubre: this.resultado[0].octubre,
            noviembre: this.resultado[0].noviembre,
            diciembre: this.resultado[0].diciembre,
            promedio: this.resultado[0].promedio,
            cuota: this.resultado[0].cuota,
          });
        }
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }



  volver(){
    this.vuelve.emit({value: false, validador: false});
  }

  getFullYear() {
    var date = new Date();
    const year = date.getFullYear()
    this.selectedYear = year
    //this.selectedYear = year+1
    this.years = [year-3, year-2, year-1, year, year+1, year+2, year+3]
    //this.years = [2025]
  }

  evluar(){
    const valores = document.querySelectorAll('#calculo input[type="text"]');
    var suma: any = 0;
    valores.forEach((val: any) => {
      if (val.value != '') suma = parseFloat(suma) + parseFloat(val.value);
    });
    var divi = parseFloat(suma) / 12;
    this.formularioRegistro.get('promedio')?.setValue((Math.ceil(divi).toString()));
    //(document.getElementById('division') as HTMLInputElement).value = (Math.ceil(divi).toString());
    //Depende del porcentaje que asignen
    //3% o 5%
    var porce = (divi * 3) / 100;
    this.formularioRegistro.get('cuota')?.setValue((Math.ceil(porce).toString()));
    //(document.getElementById('porcentaje') as HTMLInputElement).value = (Math.ceil(porce).toString());
    /*
    Math.round(1.5) dará como resultado 2.
    Math.round(1.4) dará como resultado 1.
    */
    console.log('Valores suma:  ', suma);
  }

  /*
  aspirantes(content: TemplateRef<any>) {
		this.modalService.open(content, { size: 'xl', scrollable: true });
	}
  */


  // En tu método consulta_combos
  /*
  consulta_combos(id: any) {
    let estado = id.value;
    this.mdl.cargando();
    this.servicios.listarEstudiantes(estado).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        // Agrega la propiedad 'seleccionado' a cada estudiante
        this.resultado = rs.data.estudiantes.map((estudiante: any) => ({
          ...estudiante,
          seleccionado: false
        }));
        this.valor = true;
        this.filteredResultado = [...this.resultado];
      },
      error: (error) => {
        this.errorMessage = error.message;
      }
    });
  }
  // Método para manejar la selección de aspirantes
  seleccionarAspirante(estudiante: any) {
    if (estudiante.seleccionado) {
      // Si el aspirante está seleccionado, añade su ID al array
      this.aspirantesSeleccionados.push(estudiante.id_estudiante);
    } else {
      // Si el aspirante fue deseleccionado, quita su ID del array
      const index = this.aspirantesSeleccionados.indexOf(estudiante.id_estudiante);
      if (index > -1) {
        this.aspirantesSeleccionados.splice(index, 1);
      }
    }
    console.log('Aspirantes seleccionados:', this.aspirantesSeleccionados);
  }

  // Tu método buscar() ya está bien, ya que filtra el array original 'resultado'.
  // Los objetos filtrados siguen apuntando a los objetos originales en 'resultado',
  // manteniendo así el estado de 'seleccionado'.
  buscar() {
    this.filteredResultado = this.resultado.filter((item: any) => {
      const identificacion = item.identificacion ? this.quitarAcentos(item.identificacion.toLowerCase()) : '';
      const nombre = item.nombre_full ? this.quitarAcentos(item.nombre_full.toLowerCase()) : '';
      const term = this.searchTerm.toLowerCase();
      return (
        identificacion.includes(term) ||
        nombre.includes(term)
      );
    });
  }
  quitarAcentos(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  */


  guardar(){
    if(!this.formularioRegistro.valid){
      this.titulo = '!ADVERTENCIA¡';
      this.tipo_color = 'warning';
      this.letra_color = 'dark';
      this.mensaje = "Debe completar los campos requeridos del formulario";
      this.mdl.alerta();
    }else{
      Object.assign(this.formularioRegistro.value, {'id_organizacion': this.id_empresa});
      console.table(this.formularioRegistro.value);
      this.mdl.cargando();
      this.servicios.guardarCalculo(this.formularioRegistro.value).subscribe({
        next: (rs) => {
          console.log(rs)
          this.mdl.cerrar();
          this.vuelve.emit({value: false, validador: true});
        },
        error: (error) => {
          this.errorMessage = error.message; // Muestra el mensaje de error al usuario
          //console.error("Error en el componente:", error); // Registro del error en el componente
        }
      });
    }
  }

  onChangeYear(event: any){
    //this.planificacion();
    console.log(event.target.value)
    this.selectedYear = event.target.value;
  }

}
